<span [matTooltip]="tooltip">
    <span #content></span>
</span>
